
































































































































import Vue from 'vue'
import { Slider, Row, Col, Button, Input } from 'element-ui'
import { required, minLength } from 'vuelidate/lib/validators'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'

const MIN_CLIP_LENGTH = 15 // seconds
const MAX_GIGABYTES = 75
const notEmpty = value => value !== '00:00:00'
const checkTime = value => {
  const units = value.split(':')
  if (units.length !== 3) {
    return false
  }
  for (let index = 0; index < 3; ++index) {
    if (units[index] === '00') {
      continue
    }
    const value = parseInt(units[index])
    if (value > 0 && value < 60) {
      continue
    }
    return false
  }
  return true
}

export default Vue.extend({
  name: 'ClipMaker',
  props: {
    source: {
      type: String,
      required: true
    },
    quality: {
      type: String,
      required: true
    }
  },
  data: () => ({
    trim: [ 0, 15 ],
    videoLength: 0,
    adjusted: 0,
    clipname: '',
    trimValid: [true, true],
    prevValues: [0, 10],
    minClipLength: MIN_CLIP_LENGTH,
    maxGigabytes: MAX_GIGABYTES
  }),
  mounted () {
    const videoElem = this.$refs.video as HTMLVideoElement|undefined
    if (videoElem) {
      videoElem.onplay = this.startPlaying
    }
  },
  validations: {
    clipname: {
      required,
      minLength: minLength(3)
    },
    duration: {
      required,
      empty: notEmpty
    },
    trimin: {
      required,
      checkTime: checkTime
    },
    trimout: {
      required,
      checkTime: checkTime
    }
  },
  computed: {
    canCreateArchive (): boolean {
      return this.$can(AbilityAction.Create, AbilitySubject.Archive)
    },
    duration (): string {
      return this.secondsToString(this.trim[1] - this.trim[0])
    },
    clipDuration (): number {
      return this.trim[1] - this.trim[0]
    },
    maxClipLength (): number {
      const bitrate = parseInt(this.quality.split('p')[1])
      const maxFileSize = MAX_GIGABYTES * (1024 ** 2) * 8
      const seconds = maxFileSize / bitrate
      return seconds
    },
    trimin: {
      get (): string {
        return this.secondsToString(this.trim[0])
      },
      set (val: string) {
        if (checkTime(val)) {
          const units = val.split(':')
          this.trim[0] = parseInt(units[0]) * 3600 + parseInt(units[1]) * 60 + parseInt(units[2])
          this.prevValues = this.trim
          this.trimValid[0] = true
        } else {
          this.trimValid[0] = false
        }
        this.adjusted += 1
      }
    },
    trimout: {
      get (): string {
        return this.secondsToString(this.trim[1])
      },
      set (val: string) {
        if (checkTime(val)) {
          const units = val.split(':')
          this.trim[1] = parseInt(units[0]) * 3600 + parseInt(units[1]) * 60 + parseInt(units[2])
          this.prevValues = this.trim
          this.trimValid[1] = true
        } else {
          this.trimValid[1] = false
        }
        this.adjusted += 1
      }
    }
  },
  methods: {
    secondsToString (val: number): string {
      const hours = Math.floor(val / 3600)
      const minutes = Math.floor((val / 60 - hours * 60))
      const seconds = Math.floor(val - (hours * 3600 + minutes * 60))
      let output = ''
      if (hours < 10) {
        output += '0'
      }
      output += hours + ':'
      if (minutes < 10) {
        output += '0'
      }
      output += minutes + ':'
      if (seconds < 10) {
        output += '0'
      }
      output += seconds
      return output
    },
    startPlaying (event): void {
      console.log('here')
      if (this.videoLength === 0) {
        this.videoLength = parseInt(event.target.duration)
        this.trim[1] = Math.min(this.videoLength, this.maxClipLength)
        this.$emit('clipInfoUpdated', this.videoLength)
      }
    },
    getVideoCurrentTime (): number {
      const videoElem = this.$refs.video as HTMLVideoElement|undefined
      if (videoElem) {
        return Math.floor(videoElem.currentTime)
      }
      return 0
    },
    marktrim (index: number): void {
      this.trim[index] = this.getVideoCurrentTime()
      if (this.trim[0] > this.trim[1]) {
        this.trim[0] = this.trim[1]
      }
      this.prevValues = this.trim
      this.adjusted += 1
    },
    sliderClicked (event): void {
      if (event[0] !== this.prevValues[0]) {
        this.moveVideoTo(event[0])
      } else if (event[1] !== this.prevValues[1]) {
        this.moveVideoTo(event[1])
      }
      this.prevValues = event
    },
    moveVideoTo (seconds: number) {
      try {
        const videoElem = this.$refs.video as HTMLVideoElement|undefined
        if (videoElem) {
          videoElem.currentTime = seconds
        }
      } catch (e) {
      }
    },
    clipNow (): void {
      this.$v.$touch()
      if (!this.$v.$invalid && this.trimValid[0] && this.trimValid[1] &&
          this.clipDuration < this.maxClipLength && this.clipDuration >= this.minClipLength) {
        this.$message('New Clips is going to be created, please wait ...')
        this.$emit('makeClip', { from: this.trim[0], to: this.trim[1], name: this.clipname })
        this.trim[0] = 0
        this.trim[1] = Math.min(this.maxClipLength, this.videoLength)
        this.clipname = ''
        this.adjusted += 1
        this.$v.$reset()
      }
    },
    slidertooltip (value: number): string {
      return this.secondsToString(value)
    }
  },
  components: {
    'el-slider': Slider,
    'el-row': Row,
    'el-col': Col,
    'el-button': Button,
    'el-input': Input
  }
})
